import { ListsState } from "./reducer";

export const selectLoading = (state: ListsState) => state.loading;

export const selectError = (state: ListsState) => state.error;

export const selectCreatingFavoriteList = (state: ListsState) => state.creatingFavoriteList;

export const selectMyLists = (state: ListsState) => state.myLists;

export const selectPublicLists = (state: ListsState) => state.publicLists;

export const selectSharedLists = (state: ListsState) => state.sharedLists;

export const selectSharedWithMeLists = (state: ListsState) => state.sharedWithMeLists;
